import React from 'react';
import ApplicationShell from './ApplicationShell';
import GeoTracker from '../Tracking/GeoTracker';

const Layout = ({ children }) => {
    return (
        <ApplicationShell>
            <GeoTracker />
            {children}
        </ApplicationShell>
    );
};

export default Layout;